<template>
  <div>
    <p>To enable monitoring in ServicePulse, you need to set up a ServiceControl Monitoring instance. There are multiple ways to do this:</p>
    <ul>
      <li>
        <strong><a href="https://docs.particular.net/servicecontrol/monitoring-instances/deployment/powershell" target="_blank">Scripted Deployment</a></strong> - Use a script to automate the installation and configuration of the monitoring instance
      </li>
      <li>
        <strong><a href="https://docs.particular.net/servicecontrol/monitoring-instances/deployment/containers" target="_blank">Containers</a></strong> - Run the monitoring instance inside a container
      </li>
      <li>
        <strong><a href="https://docs.particular.net/servicecontrol/monitoring-instances/deployment/scmu" target="_blank">ServiceControl Management Utility</a></strong> - Use the management utility to create and configure the monitoring instance
      </li>
    </ul>
    <p>The monitoring instance collects and aggregates metrics from your endpoints.</p>
  </div>
</template>
